export const YUJ = {
  nav: "yuj-nav",
  navLogo: "yuj-nav-logo",
  navMenuButton: "yuj-nav-menu-button",
  navLink: (id) => `yuj-nav-link-${id}`,
  ctaBookTrial: "yuj-cta-book-trial",
  ctaExplorePrograms: "yuj-cta-explore-programs",
  ctaWhatsapp: "yuj-cta-whatsapp",
  ctaPhone: "yuj-cta-phone",
  ctaEmail: "yuj-cta-email",
  ctaInstagram: "yuj-cta-instagram",
  ctaFacebook: "yuj-cta-facebook",
  ctaMap: "yuj-cta-map",
  ctaFooterBook: "yuj-footer-book",
  heroSection: "yuj-hero",
  heroLogo: "yuj-hero-logo",
  aboutSection: "yuj-about",
  programsSection: "yuj-programs",
  programCard: (id) => `yuj-program-card-${id}`,
  moreThanFitness: "yuj-more-than-fitness",
  featureCard: (id) => `yuj-feature-card-${id}`,
  whyChoose: "yuj-why-choose",
  whyCard: (id) => `yuj-why-card-${id}`,
  gallerySection: "yuj-gallery",
  galleryImage: (i) => `yuj-gallery-image-${i}`,
  marqueeSection: "yuj-marquee",
  foundersSection: "yuj-founders",
  founderCard: (id) => `yuj-founder-${id}`,
  locationSection: "yuj-location",
  contactSection: "yuj-contact",
  footer: "yuj-footer",
  signatureLine: "yuj-signature-line",
  mobileDrawer: "yuj-mobile-drawer",
};
